import { Component } from '@angular/core';
import { LoyaltyPaymentListComponent } from 'libs/shared/src/lib/component/loyalty/loyalty-payment-list/loyalty-payment-list.component';

@Component({ standalone: false, selector: 'app-loyalty-payment-list', templateUrl: './loyalty-payment-list.component.html' })
export class CustomLoyaltyPaymentListComponent extends LoyaltyPaymentListComponent {}
